import { useMutation, useQuery } from "@tanstack/react-query";

import { HttpQuery } from "@Types/http";
import { MutationError } from "@Types/index";
import { LenderBlogPost } from "@Types/lender_blogposts";
import { getPosts, getBlogPost, likePost } from "@Http/lender_blogposts";

import { queryClient } from "../App";

const useGetBlogPosts = (query?: HttpQuery) => {
  const queryKey = ["blog-posts-lender", query ?? []];

  const { data, isLoading, error } = useQuery<
    LenderBlogPost[],
    MutationError,
    LenderBlogPost[]
  >({
    queryKey: queryKey,
    queryFn: getPosts(query),
  });

  return {
    data,
    isLoading,
    error,
  };
};
export const useGetBlogPost = (id: string) => {
  const queryKey = [`blog-post-lender-${id}`];

  const {
    data: blog,
    isLoading,
    error,
    isSuccess,
  } = useQuery({
    queryKey: queryKey,
    queryFn: getBlogPost(id),
  });

  return {
    isSuccess,
    blog,
    isLoading,
    error,
  };
};

export const useLikeBlogPost = (id: string) => {
  const mutation = useMutation<LenderBlogPost, MutationError, { id: string }>(
    likePost(id),
    {
      onSuccess: (data) => {
        queryClient.setQueryData<LenderBlogPost>(
          [`blog-post-${id}`],
          () => data
        );
      },
    }
  );
  return {
    like: mutation.mutate,
    loading: mutation.isLoading,
    success: mutation.isSuccess,
    error: mutation.error,
  };
};

export default useGetBlogPosts;
